import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark border-t border-white/10 pt-10 pb-6 sm:pt-16 sm:pb-8 text-center" data-id="element-67">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <h2 className="text-lg sm:text-2xl font-black text-white mb-3 sm:mb-4 tracking-wide" data-id="element-69">
          🛠️ KIT DE PRESUPUESTOS RÁPIDOS RESUELTO™
        </h2>

        <p className="text-xs sm:text-sm text-gray-400 mb-8 sm:mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-70">
          El sistema de cotización y cierre N°1 para profesionales de la
          construcción y el diseño en Argentina. Porque cerrar obras de
          remodelación de alto valor no debería costarte tus noches libres ni
          dolores de cabeza con los clientes.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-3 sm:gap-4 md:gap-8 text-xs sm:text-sm text-gray-500 mb-8 sm:mb-12" data-id="element-71">
          <a href="mailto:contacto@presupuestosfitness.shop" className="hover:text-brand-accent transition-colors" data-id="element-72">
            contacto@presupuestosfitness.shop
          </a>
          <span className="hidden md:inline" data-id="element-73">•</span>
          <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-74">
            @presupuestos.ar
          </a>
          <span className="hidden md:inline" data-id="element-75">•</span>
          <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-76">
            presupuestosremodelacion.shop
          </a>
        </div>

        <div className="border-t border-white/10 pt-6 sm:pt-8" data-id="element-77">
          <p className="text-[10px] sm:text-xs text-gray-600" data-id="element-78">
            © PresupuestosRemodelacion.shop™ 2026 — Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}